'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultTunnel = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _httpErrors = require('http-errors');

var _httpErrors2 = _interopRequireDefault(_httpErrors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Mock tunnel
 * @type {{metrics: {getUrlSegment: ((p1:string)=>{getTrace: (()=>number), close: (())})}, log: Console}}
 */
var defaultTunnel = exports.defaultTunnel = {
    metrics: {
        getUrlSegment: function getUrlSegment() {
            return {
                getTrace: function getTrace() {
                    return 1;
                },
                close: function close() {}
            };
        }
    },
    log: console
};

// Types

/**
 * On Success handler
 * @param {Response} response The response from Fetch
 * @param {RequestTunnel} reqTunnel The tunnel containing the metrics and logger instances
 * @returns {*} The response from the external service
 */
var onSuccess = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(response, reqTunnel) {
        var headers, status, url, segment, log, method, result;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        headers = response.headers, status = response.status, url = response.url;
                        segment = reqTunnel.segment, log = reqTunnel.log, method = reqTunnel.method;
                        result = void 0;

                        if (!(headers.get('content-type') && headers.get('content-type').indexOf('application/json') > -1)) {
                            _context.next = 9;
                            break;
                        }

                        _context.next = 6;
                        return response.json();

                    case 6:
                        result = _context.sent;
                        _context.next = 12;
                        break;

                    case 9:
                        _context.next = 11;
                        return response.text();

                    case 11:
                        result = _context.sent;

                    case 12:

                        segment.close(status);
                        log.info('[' + method + '] Request for ' + url + ' successful. CODE: ' + status + '. Duration: ' + segment.getTrace() + 'ms');
                        return _context.abrupt('return', result);

                    case 15:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function onSuccess(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

/**
 * Error response handler
 * @param {Response} response The response from Fetch
 * @param {RequestTunnel} reqTunnel The tunnel containing the metrics and logger instances
 * @param {Error} [error] The error thrown while processing the request
 * @returns {void}
 * @throws {SyntaxError|HttpError} The error returned by a failed response processing or an HTTP error matching the
 * response status code
 */
var onError = function onError(response, reqTunnel, error) {
    var url = response.url,
        status = response.status;
    var log = reqTunnel.log,
        segment = reqTunnel.segment,
        method = reqTunnel.method;

    var errorMsg = '[' + method + '] Request for ' + url + ' failed. CODE: ' + status + '. Duration: ' + segment.getTrace() + 'ms.';

    segment.close(status);

    if (error) {
        segment.error = error.message;
        log.error(errorMsg, error);
        throw error;
    } else {
        log.warn(errorMsg);
        throw (0, _httpErrors2.default)(status);
    }
};

/**
 * On response handler which validates the request succeded - status code < 300
 * @param {Response} response The response from Fetch
 * @param {RequestTunnel} reqTunnel The tunnel containing the metrics and logger instances
 * @returns {*} The data returned by the endpoint after processing
 */
var onResponse = function () {
    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(response, reqTunnel) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        if (!(response && response.ok)) {
                            _context2.next = 2;
                            break;
                        }

                        return _context2.abrupt('return', onSuccess(response, reqTunnel));

                    case 2:
                        return _context2.abrupt('return', onError(response, reqTunnel));

                    case 3:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function onResponse(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

/**
 * Fetches data for a given endpoint and options. This intends to be a soft wrapper on top of the Fetch API to
 * abstract logging and error handling across all requests
 * @param {string} endpoint The endpoint to be requested
 * @param {TunnelType} tunnel The tunnel containing the metrics and logger instances
 * @param {RequestOptions} [options] The options to be passed to the FetchAPI
 * @returns {*} The response
 */

exports.default = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(endpoint, tunnel) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var metrics, log, segment, response, method, reqTunnel;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        // eslint-disable-line flowtype/no-weak-types
                        metrics = tunnel.metrics, log = tunnel.log;
                        segment = metrics.getUrlSegment(endpoint);
                        _context3.next = 4;
                        return fetch(endpoint, options);

                    case 4:
                        response = _context3.sent;
                        method = options.method || 'GET';
                        reqTunnel = {
                            segment: segment,
                            log: log,
                            method: method
                        };

                        segment.method = method;
                        log.info('[' + method + '] Request for ' + endpoint + ' started.');

                        _context3.prev = 9;
                        _context3.next = 12;
                        return onResponse(response, reqTunnel);

                    case 12:
                        return _context3.abrupt('return', _context3.sent);

                    case 15:
                        _context3.prev = 15;
                        _context3.t0 = _context3['catch'](9);
                        _context3.next = 19;
                        return onError(response, reqTunnel, _context3.t0);

                    case 19:
                        return _context3.abrupt('return', _context3.sent);

                    case 20:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this, [[9, 15]]);
    }));

    function dataProvider(_x5, _x6) {
        return _ref3.apply(this, arguments);
    }

    return dataProvider;
}();
//# sourceMappingURL=dataProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/data-provider/dataProvider.js
// module id = 444
// module chunks = 0